import { maApiFetch } from './maApi'
import { notifyError, notifySuccess, validate } from '../utils/helpers'
import { formDataJson } from '../utils/dataFormatting'

export const onSubmit = (state, dispatch, setIsSubmitting, maApiHost, authenticatedFetch) => {
  const { onClose } = dispatch
  const { requests, requestType } = state
  const { fields } = requests[requestType]
  const invalidFields = validate(fields)

  dispatch.updateValidation()
  if (invalidFields.length === 0) {
    setIsSubmitting(true)
    const data = formDataJson(fields)

    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    }

    maApiFetch('/eod/cases', options, maApiHost, authenticatedFetch)
      .then(response => {
        if (response.errors) {
          throw new Error(response.errors)
        } else {
          notifySuccess('Free-form request', `Your request #${response.case_number} has been submitted.`)
          onClose()
        }
      })
      .catch(error => {
        notifyError('Error', 'We are unable to complete your request. Please try again.')
        setIsSubmitting(false)
        throw new Error(error)
      })
  }
}
